export default {
    dependencies: ['$element', 'xhrservice', 'objectstore'],
    callable(element, xhrservice, objectstore) {
        element.addEventListener('click', onLogOutClick);
        function onLogOutClick() {
            objectstore.clear();
            try {
                window.localStorage.setItem('must-revalidate-login', 'yup');
            } catch (e) {}
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/logOut.js